import { render } from "./ClipboardView.vue?vue&type=template&id=48c20f2a&scoped=true"
import script from "./ClipboardView.vue?vue&type=script&lang=js"
export * from "./ClipboardView.vue?vue&type=script&lang=js"

import "./ClipboardView.vue?vue&type=style&index=0&id=48c20f2a&scoped=true&lang=css"

import exportComponent from "D:\\project\\clipshare\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c20f2a"]])

export default __exports__